import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendWaiterRequest } from "../../redux/action";
import "./waiter.scss";

export default function WaiterPopup({ isOpen, onClose }) {
  const dispatch = useDispatch();
  const [message, setMessage] = useState("");

  if (!isOpen) return null;

  return (
    <div className="waiterPopupOverlay">
      <div className="waiterPopupBox">
        <span className="close-btn round-close-btn" onClick={onClose}>
          &times;
        </span>

        <h3 className="waiterPopupTitle">
          This is your waiter. How may I help you?
        </h3>

        <div className="buttonRow">
          <button className="btn" onClick={() => setMessage("Attend my table")}>
            Attend my table
          </button>
          <button className="btn" onClick={() => setMessage("Bring Water")}>
            Bring Water
          </button>
          <button className="btn" onClick={() => setMessage("Bring Cutlery")}>
            Bring Cutlery
          </button>
          <button className="btn" onClick={() => setMessage("Bring Bill")}>
            Bring Bill
          </button>
        </div>

        <textarea
          placeholder="Enter your message here"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <button
          className="sendBtn btn"
          onClick={() => dispatch(sendWaiterRequest(message))}
        >
          Send Request
        </button>
      </div>
    </div>
  );
}
